import { render, staticRenderFns } from "./leftBox-tj.vue?vue&type=template&id=9df0c4ca&scoped=true"
import script from "./leftBox-tj.vue?vue&type=script&lang=js"
export * from "./leftBox-tj.vue?vue&type=script&lang=js"
import style0 from "./leftBox-tj.vue?vue&type=style&index=0&id=9df0c4ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df0c4ca",
  null
  
)

export default component.exports